import React from 'react'
import styled from 'styled-components'
import themeColors from '@layers-frontend/commons/styles/themeColors'
import { pillLooks } from '../UIComponents/StyledButtons'

import get from 'lodash/get'
import includes from 'lodash/includes'

const GoToFieldButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

const MapIcon = styled.i`
  padding-right: 5px;
  color: ${themeColors.mintColor};
  transition: color 0.15s;
`

// The outline pill, like Geometría. Its 1px border is the mint contour, so the look's inset contour is dropped and the
// button keeps its size.
const GoToFieldButton = styled.button`
  border: 1px solid ${themeColors.mintColor};
  padding: 4px 6px;
  cursor: pointer;
  ${pillLooks.outline};
  box-shadow: none;
  &:hover ${MapIcon} {
    color: ${themeColors.deepblueColor3};
  }
`

export default function ReportGoToFieldsButton({ goToField, closeModal, fieldsIds, t }) {
  const urlPathName = get(window, 'location.href')
  const isDashboard = includes(urlPathName, 'dashboard')

  const handleSelectFields = () => {
    closeModal()
    goToField(fieldsIds, isDashboard)
  }

  return (
    <GoToFieldButtonContainer>
      <GoToFieldButton onClick={handleSelectFields}>
        <MapIcon className="far fa-map" />
        {t('go to field')}
      </GoToFieldButton>
    </GoToFieldButtonContainer>
  )
}
